import { render, staticRenderFns } from "./viewAdPlacement.vue?vue&type=template&id=5fe4e48d&"
import script from "./viewAdPlacement.vue?vue&type=script&lang=js&"
export * from "./viewAdPlacement.vue?vue&type=script&lang=js&"
import style0 from "./viewAdPlacement.vue?vue&type=style&index=0&id=5fe4e48d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports